import * as actionTypes from "./../../Constants/clients/clientActionTypes";
import API from "./../../Constants/clients/API";
import * as clientServices from "../../services/clients/index";

export const newClients = (clientData, request) => ({
    type: actionTypes.SAVE_EDITS,
    payload: { clientData: [...clientData, ...request]
    }
})

export function saveEdits (client, allClients) {
    return async dispatch => {
        const clientsReportData = await clientServices.req.setAllClients(API.saveAllClients, client)
        return dispatch({
            type: actionTypes.GET_SAVED_CLIENTS_DATA,
            payload: { clientsReportData }
        });
    };
}

export function saveStaff(staffDet) {
    return async dispatch => {
        const staffReportData = await clientServices.req.updateStaffs(API.updateStaffDetails, staffDet)
        return dispatch({
            type: actionTypes.UPDATE_STAFF_DATA,
            payload: { staffReportData }
        });
    };
}

export function updateDefaultClients(clients) {
    return async dispatch => {
        return dispatch({
            type: actionTypes.UPDATE_DEFAULT_CLIENTS,
            payload: { clients }
        });
    };
}